import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const useResponsiveDevice = () => {
  const [currentDevice, setCurrentDevice] = useState("desktop");
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const getResponsiveConfig = async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}system/settings`, {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "x-access-token": localStorage.getItem("token")
          }
        }); // Your API
        setConfig(data?.data?.responsive);
      } catch (err) {
        console.error(err);
      }
    };

    getResponsiveConfig();
  }, []);

  useEffect(() => {
    if (!config) return;

    const getDevice = () => {
      const width = window.innerWidth;

      if (
        width >= config.mobile.min &&
        width <= config.mobile.max
      ) {
        setCurrentDevice("mobile");
      } else if (
        width >= config.tablet.min &&
        width <= config.tablet.max
      ) {
        setCurrentDevice("tablet");
      } else {
        setCurrentDevice("desktop");
      }
    };

    getDevice();

    window.addEventListener("resize", getDevice);

    return () => window.removeEventListener("resize", getDevice);
  }, [config]);

  return currentDevice;
};

export default useResponsiveDevice;